<template>
  <v-card>
    <v-card-title class="headline grey darken-4">
      <v-icon left color="primary">mdi-cash-plus</v-icon>
      Suprimento de caixa
      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-text>
      <MoneyInput class="my-4" v-model="supply.amount" label="Valor do Suprimento" @keydown.enter="register()" />
    </v-card-text>
  </v-card>
</template>


<script>
  import { mapActions, mapState } from "vuex";
  export default {
    data() {
      return {

        supply: {
          amount: 0,
          remark: "Suprimento",
        },
      };
    },
    methods: {
      ...mapActions("supply", ["storeSupply"]),
      ...mapActions("cashier", ["activeCashier"]),

      register() {
        this.storeSupply(this.supply).then(() => {



        })
        this.$emit('close-dialog');
      },
    },

    computed: {
      ...mapState("cashier", ["cashier"]),

    },
  };
</script>